// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gN-z","twoColumnImage":"hN-z"};